import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import BigNumber from 'bignumber.js'
import { CashbackBonusType } from 'config/types/bonus/userBonus'
import { Trans } from 'react-i18next'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { BonusContentFieldTitle, BonusContentGridSystem } from '../../styled'

const CashbackBonusContent: React.FC<{ bonus: CashbackBonusType } & BoxProps> = ({ bonus, ...props }) => {
  return (
    <>
      <BonusContentGridSystem {...props} my="4px" mt="16px">
        <BonusContentFieldTitle>{<Trans>Current profit</Trans>}</BonusContentFieldTitle>
        <Flex alignItems="center">
          <Text
            fontWeight="600"
            fontSize="14px"
            ml="4px"
            lineHeight="normal"
            color={
              new BigNumber(bonus.cashbackProfitAmountInUsd).gt(0)
                ? 'success'
                : new BigNumber(bonus.cashbackProfitAmountInUsd).lt(0)
                ? 'error'
                : 'text'
            }
          >
            ${getFullDisplayBalance(bonus.cashbackProfitAmountInUsd, 0, 5)}
          </Text>
        </Flex>
      </BonusContentGridSystem>

      <BonusContentGridSystem {...props} my="4px">
        <BonusContentFieldTitle style={{ wordBreak: 'keep-all', whiteSpace: 'nowrap' }}>
          {<Trans>Est. Cashback</Trans>}
        </BonusContentFieldTitle>
        <Text fontWeight="600" fontSize="14px" ml="4px" lineHeight="normal">
          ${getFullDisplayBalance(bonus.cashbackReturnAmountInUsd, 0, 6)}
        </Text>
      </BonusContentGridSystem>
    </>
  )
}

export default CashbackBonusContent
